// extracted by mini-css-extract-plugin
export var ateamStyles = "auxiliary-teams-module--ateamStyles--zCqLl";
export var divTagline = "auxiliary-teams-module--divTagline--3iKwu";
export var divP = "auxiliary-teams-module--divP--+6g3+";
export var globeStyles = "auxiliary-teams-module--globeStyles--fsX+7";